import React, { Component } from 'react'
//import 'bootstrap/dist/css/bootstrap.css'
import { Route, BrowserRouter, Link, Redirect, Switch } from 'react-router-dom'
import LoginPage from '../pages/LoginPage/LoginPage'
import AboutPage from '../pages/AboutPage/AboutPage'
import HomePage from '../pages/HomePage/HomePage'
import DashboardPage from '../pages/DashboardPage/DashboardPage'

import PublisherPageList from '../pages/PublisherPage/PublisherPageList'
import PublisherPageView from '../pages/PublisherPage/PublisherPageView'
import PublisherPageAdd from '../pages/PublisherPage/PublisherPageAdd'
import PublisherPageEdit from '../pages/PublisherPage/PublisherPageEdit'

import MagazinePageList from '../pages/MagazinePage/MagazinePageList'
import MagazinePageView from '../pages/MagazinePage/MagazinePageView'
import MagazinePageAdd from '../pages/MagazinePage/MagazinePageAdd'
import MagazinePageEdit from '../pages/MagazinePage/MagazinePageEdit'

import IssuePageList from '../pages/IssuePage/IssuePageList'
import IssuePageView from '../pages/IssuePage/IssuePageView'
import IssuePageAdd from '../pages/IssuePage/IssuePageAdd'
import IssuePageEdit from '../pages/IssuePage/IssuePageEdit'

import File_cover_url_listPageList from '../pages/File_cover_url_listPage/File_cover_url_listPageList'
import File_cover_url_listPageView from '../pages/File_cover_url_listPage/File_cover_url_listPageView'
import File_cover_url_listPageAdd from '../pages/File_cover_url_listPage/File_cover_url_listPageAdd'
import File_cover_url_listPageEdit from '../pages/File_cover_url_listPage/File_cover_url_listPageEdit'
import File_cover_url_listPageListByIssue from '../pages/File_cover_url_listPage/File_cover_url_listPageListByIssue'


import File_book_download_url_listPageList from '../pages/File_book_download_url_listPage/File_book_download_url_listPageList'
import File_book_download_url_listPageView from '../pages/File_book_download_url_listPage/File_book_download_url_listPageView'
import File_book_download_url_listPageAdd from '../pages/File_book_download_url_listPage/File_book_download_url_listPageAdd'
import File_book_download_url_listPageEdit from '../pages/File_book_download_url_listPage/File_book_download_url_listPageEdit'
import File_book_download_url_listPageListByIssue from '../pages/File_book_download_url_listPage/File_book_download_url_listPageListByIssue'


import UploadPageBookCover from '../pages/UploadPage/UploadPageBookCover'
import UploadPageBookZip from '../pages/UploadPage/UploadPageBookZip'

import D2hPublishMagazinePageList from '../pages/D2hPublishMagazinePage/D2hPublishMagazinePageList'
import D2hPublishMagazinePageView from '../pages/D2hPublishMagazinePage/D2hPublishMagazinePageView'
import D2hPublishMagazinePageAdd from '../pages/D2hPublishMagazinePage/D2hPublishMagazinePageAdd'
import D2hPublishMagazinePageEdit from '../pages/D2hPublishMagazinePage/D2hPublishMagazinePageEdit'


import { logout } from '../../helpers/auth'
import { firebaseAuth, basename } from '../../config/constants'

function PrivateRoute ({component: Component, authed, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => authed === true
        ? <Component {...props} />
        : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
    />
  )
}

function PublicRoute ({component: Component, authed, ...rest}) {
  return (
    <Route
      {...rest}
      render={(props) => authed === false
        ? <Component {...props} />
        : <Redirect to='/dashboard' />}
    />
  )
}

export default class App extends Component {
  state = {
    authed: false,
    loading: true,
  }
  componentDidMount () {
    this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authed: true,
          loading: false,
        })
      } else {
        this.setState({
          authed: false,
          loading: false
        })
      }
    })
  }
  componentWillUnmount () {
    this.removeListener()
  }
  render() {
    return this.state.loading === true ? <h1>Loading</h1> : (
      <BrowserRouter basename={basename} >
        <div id="wrapper">
          {/* Navigation */}
          <nav className="navbar navbar-default navbar-static-top" role="navigation" style={{marginBottom: 0}}>
            <div className="navbar-header">
              <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>
              {/*
              <a className="navbar-brand" href="/"></a>
              */}
              <Link to="/" className="navbar-brand">Bookkerry D2H Admin</Link>
            </div>
            {/* /.navbar-header */}

            <ul className="nav navbar-top-links navbar-right">
              {this.state.authed
                ?
                <li>
                  <a href="#"
                    onClick={() => { logout() }}>
                    <i className="fa fa-sign-out fa-fw" /> Logout</a>
                </li>
                :
                <li>
                  <Link to="/dashboard"> <i className="fa fa-book fa-fw"/>Login</Link>
                </li>
                }
            </ul>

            {/* /.navbar-top-links */}
            <div className="navbar-default sidebar" role="navigation">
              <div className="sidebar-nav navbar-collapse">
                <ul className="nav" id="side-menu">
                  <li>
                    <Link to="/dashboard"><i className="fa fa-dashboard fa-fw" />Dashboard</Link>
                  </li>
                  <li>
                    <Link to="/d2hpublishmagazine"> <i  className="fa fa-arrow-circle-right fa-fw"/>D2H Console</Link>
                  </li>
                  <li>
                    <Link to="/publisher"> <i className="fa fa-book fa-fw"/>Publisher</Link>
                  </li>
                  <li>
                    <a href="#"><i className="fa fa-futbol-o fa-fw" /> Models<span className="fa arrow" /></a>
                    <ul className="nav nav-second-level">
                      <li>
                        <Link to="/d2hpublishmagazine"><i className="fa fa-arrow-circle-right fa-fw" />D2hPublishMagazine</Link>
                      </li>
                      <li>
                        <Link to="/publisher"> <i className="fa fa-arrow-circle-right fa-fw" />Publisher</Link>
                      </li>
                      <li>
                        <Link to="/magazine"> <i className="fa fa-arrow-circle-right fa-fw" />Magazine</Link>
                      </li>
                      <li>
                        <Link to="/issue"> <i className="fa fa-arrow-circle-right fa-fw" />Issue</Link>
                      </li>
                      <li>
                        <Link to="/file_cover_url_list"><i className="fa fa-arrow-circle-right fa-fw" />file_cover_url_list</Link>
                      </li>
                      <li>
                        <Link to="/file_book_download_url_list"><i className="fa fa-arrow-circle-right fa-fw" />file_book_download_url_list</Link>
                      </li>
                    </ul>
                    {/* /.nav-second-level */}
                  </li>
                </ul>
              </div>
              {/* /.sidebar-collapse */}
            </div>
            {/* /.navbar-static-side */}
          </nav>
          {/* Page Content */}
          <div id="page-wrapper">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <Switch>
                    <Route path='/' exact component={HomePage} />
                    <PublicRoute authed={this.state.authed} path='/login' component={LoginPage} />
                    <PublicRoute authed={this.state.authed} path='/about' component={AboutPage} />
                    <PrivateRoute authed={this.state.authed} path='/dashboard' component={DashboardPage} />

                    <PrivateRoute authed={this.state.authed} path='/publisher' exact component={PublisherPageList} />
                    <PrivateRoute authed={this.state.authed} path='/publisher/add' exact component={PublisherPageAdd} />
                    <PrivateRoute authed={this.state.authed} path='/publisher/view/:id' exact component={PublisherPageView} />
                    <PrivateRoute authed={this.state.authed} path='/publisher/edit/:id' exact component={PublisherPageEdit} />

                    <PrivateRoute authed={this.state.authed} path='/magazine' exact component={MagazinePageList} />
                    <PrivateRoute authed={this.state.authed} path='/magazine/add/:publisher_id' exact component={MagazinePageAdd} />
                    <PrivateRoute authed={this.state.authed} path='/magazine/view/:id' exact component={MagazinePageView} />
                    <PrivateRoute authed={this.state.authed} path='/magazine/edit/:id' exact component={MagazinePageEdit} />

                    <PrivateRoute authed={this.state.authed} path='/issue' exact component={IssuePageList} />
                    <PrivateRoute authed={this.state.authed} path='/issue/add/:magazine_id' exact component={IssuePageAdd} />
                    <PrivateRoute authed={this.state.authed} path='/issue/view/:id' exact component={IssuePageView} />
                    <PrivateRoute authed={this.state.authed} path='/issue/edit/:id' exact component={IssuePageEdit} />

                    <PrivateRoute authed={this.state.authed} path='/file_cover_url_list' exact component={File_cover_url_listPageList} />
                    <PrivateRoute authed={this.state.authed} path='/file_cover_url_list/add' exact component={File_cover_url_listPageAdd} />
                    <PrivateRoute authed={this.state.authed} path='/file_cover_url_list/view/:id' exact component={File_cover_url_listPageView} />
                    <PrivateRoute authed={this.state.authed} path='/file_cover_url_list/edit/:id' exact component={File_cover_url_listPageEdit} />
                    <PrivateRoute authed={this.state.authed} path='/file_cover_url_list/issue/:issue_id' exact component={File_cover_url_listPageListByIssue} />


                    <PrivateRoute authed={this.state.authed} path='/file_book_download_url_list' exact component={File_book_download_url_listPageList} />
                    <PrivateRoute authed={this.state.authed} path='/file_book_download_url_list/add' exact component={File_book_download_url_listPageAdd} />
                    <PrivateRoute authed={this.state.authed} path='/file_book_download_url_list/view/:id' exact component={File_book_download_url_listPageView} />
                    <PrivateRoute authed={this.state.authed} path='/file_book_download_url_list/edit/:id' exact component={File_book_download_url_listPageEdit} />
                    <PrivateRoute authed={this.state.authed} path='/file_book_download_url_list/issue/:issue_id' exact component={File_book_download_url_listPageListByIssue} />

                    <PrivateRoute authed={this.state.authed} path='/upload-book-cover/:issue_id' exact component={UploadPageBookCover} />
                    <PrivateRoute authed={this.state.authed} path='/upload-book-zip/:issue_id' exact component={UploadPageBookZip} />

                    <PrivateRoute authed={this.state.authed} path='/d2hpublishmagazine' exact component={D2hPublishMagazinePageList} />
                    <PrivateRoute authed={this.state.authed} path='/d2hpublishmagazine/add' exact component={D2hPublishMagazinePageAdd} />
                    <PrivateRoute authed={this.state.authed} path='/d2hpublishmagazine/view/:id' exact component={D2hPublishMagazinePageView} />
                    <PrivateRoute authed={this.state.authed} path='/d2hpublishmagazine/edit/:id' exact component={D2hPublishMagazinePageEdit} />

                    <Route render={() => <h3>No Match</h3>} />
                  </Switch>
                </div>
                {/* /.col-lg-12 */}
              </div>
              {/* /.row */}
            </div>
            {/* /.container-fluid */}
          </div>
          {/* /#page-wrapper */}
        </div>
        {/* /#wrapper */}

      </BrowserRouter>
      /*
      <BrowserRouter>
        <div>
          <nav classNameName="navbar navbar-default navbar-static-top">
            <div className="container">
              <div className="navbar-header">
                <Link to="/" className="navbar-brand">React Router + Firebase Auth</Link>
              </div>
              <ul className="nav navbar-nav pull-right">
                <li>
                  <Link to="/" className="navbar-brand">Home</Link>
                </li>
                <li>
                  <Link to="/dashboard" className="navbar-brand">Dashboard</Link>
                </li>
                <li>
                  {this.state.authed
                    ? <button
                        style={{border: 'none', background: 'transparent'}}
                        onClick={() => {
                          logout()
                        }}
                        className="navbar-brand">Logout</button>
                    : <span>
                        <Link to="/login" className="navbar-brand">Login</Link>
                        <Link to="/register" className="navbar-brand">Register</Link>
                      </span>}
                </li>
              </ul>
            </div>
          </nav>
          <div className="container">
            <div className="row">
              <Switch>
                <Route path='/' exact component={HomePage} />
                <PublicRoute authed={this.state.authed} path='/login' component={LoginPage} />
                <PublicRoute authed={this.state.authed} path='/about' component={AboutPage} />
                <PrivateRoute authed={this.state.authed} path='/dashboard' component={DashboardPage} />
                <Route render={() => <h3>No Match</h3>} />
              </Switch>
            </div>
          </div>
        </div>
      </BrowserRouter>
      */
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/App.js